const information = {
  title: 'Información de expedientes',
};

export default information;
